import { Component, OnInit } from "@angular/core";
import { OidcSecurityService } from "angular-auth-oidc-client";

import { imgUrl } from "src/assets/imgUrl";
import { PriLoginService } from "./priLoginComp/service/pri-login.service";
import { environment } from "./../environments/environment";
import { ActivatedRoute } from "@angular/router";

import { SpinnerLoaderService } from "./interceptor/spinner-loader.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  public imglist = imgUrl;
  title = "LS-Login-App-UI";
  opcoConfigObj: any;
  loadSpinner: boolean;
  configFeteched = false;
  languageFetched = false;
  footerText = "Life Science Digital. All right are reserved";

  constructor(
    private readonly priLoginService: PriLoginService,
    public readonly oidcSecurityService: OidcSecurityService,
    private readonly route: ActivatedRoute,
    private readonly loader: SpinnerLoaderService
  ) {
    this.loader.isLoading.subscribe((loadServ) => {
      setTimeout(() => {
        this.loadSpinner = loadServ;
      }, 10);
    });
  }

  ngOnInit() {
    this.route.queryParams.subscribe((par: any) => {
      const clientName = sessionStorage.getItem("clientName");
      if (location.search.indexOf("client=") !== -1) {
        if (!this.configFeteched && par.client) {
          this.configFeteched = true;

          this.priLoginService.getOpcoConfiguration(par.client);
        }
      } else if (clientName) {
        if (!this.configFeteched) {
          this.configFeteched = true;

          this.priLoginService.getOpcoConfiguration(clientName);
        }
      }

      if (location.search.indexOf("language=") !== -1) {
        if (!this.languageFetched && par.language) {
          this.languageFetched = true;

          sessionStorage.setItem("language", par.language);
        }
      } else if (sessionStorage.getItem("language")) {
        if (!this.languageFetched) {
          this.languageFetched = true;
        }
      } else {
        sessionStorage.setItem("language", navigator.language);
      }
    });
    this.priLoginService.opcoConfig.subscribe((res: any) => {
      this.opcoConfigObj = res;
      this.footerText = res.footer ? res.footer : this.footerText;
      localStorage.setItem("opcoConfig", JSON.stringify(this.opcoConfigObj));
      this.addCustomProperty(res);
    });

    this.oidcSecurityService
      .checkAuth()
      .subscribe(({ isAuthenticated, accessToken }) => {
        this.getAshtonToken();
      });
  }
  private getAshtonToken() {

    const reqObjs = JSON.parse(
      sessionStorage.getItem(environment.opco)
    );

    if (reqObjs != null) {
      const reqObj = {
        id_token: reqObjs.authnResult.id_token!=undefined? reqObjs.authnResult.id_token:"",
        access_token: reqObjs.authnResult.access_token,
        refresh_token: reqObjs.authnResult.refresh_token,
        expires_in: reqObjs.authnResult.expires_in.toString(),
        token_type: reqObjs.authnResult.token_type,
        state: reqObjs.authnResult.state,
        session_state: null,
      };
      this.priLoginService.getAshtonToken(reqObj).subscribe((res) => {
        this.priLoginService.loginMessage.next({
          errorMessage: "",
          successMessage: "Login successful",
        });

        localStorage.setItem("opcoConfig", JSON.stringify(this.opcoConfigObj));
        const IdToken = JSON.parse(
          atob(
            JSON.parse(atob(res.token.split(".")[1]))["IdToken"].split(".")[1]
          )
        );
        const email = IdToken["email"];
        const maxAge = environment.cookieExpiryDays * 24 * 60 * 60;
        if (sessionStorage.getItem("hasUserConsent") === "yes") {
          document.cookie = `ashton_user_1=${email}; max-age=${maxAge};`;
          sessionStorage.removeItem("hasConsent");
        } else if (
          document.cookie.indexOf("ashton_user") !== -1 &&
          document.cookie.indexOf(email) === -1
        ) {
          const cookies = document.cookie.split(";");
          const userNumber =
            1 + Number(cookies[cookies.length - 1].split("=")[0].split("_")[2]);
          document.cookie = `ashton_user_${userNumber}=${email}; max-age=${maxAge}; domian=${location.host}`;
        } else if (document.cookie.indexOf("ashton_user") !== -1) {
          const cookies = document.cookie.split(";");
          const isEmailUsed = cookies.find(
            (cookie) => cookie.indexOf(email) !== -1
          );
          document.cookie = `${isEmailUsed}; max-age=${maxAge};`;
        }

        sessionStorage.clear();
        window.open(`${environment.redirectUrl}/${res["token"]}`, "_self");
      });
    }
  }

  private addCustomProperty(res) {
    if (this.opcoConfigObj["cssPath"]) {
      const customStyle = document.createElement("link");
      customStyle.setAttribute("href", this.opcoConfigObj["cssPath"]);
      customStyle.setAttribute("rel", "stylesheet");
      const head = document.querySelector("head");
      head.appendChild(customStyle);
    }

    if (res["tenantId"]) {
      sessionStorage.setItem("tenantId", res["tenantId"]);
    }
    if (res["name"]) {
      sessionStorage.setItem("clientName", res["name"]);
    }

    if (this.opcoConfigObj["logoUrl"]) {
      const tabIcon = document.querySelector('link[type="image/x-icon"]');
      tabIcon.setAttribute("href", this.opcoConfigObj["logoUrl"]);
    }
    if (this.opcoConfigObj["tabTitle"]) {
      const tabTitle = document.querySelector("title");
      tabTitle.innerHTML = this.opcoConfigObj["tabTitle"];
    }
  }
}
